import {HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import {SHOW_LOADER} from '../core/interceptors/loader.interceptor';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {environment} from '../../environments/environment';
import {SignupRequest} from '../models/signup-request.model';
import {CompanyData} from '../models/company-data.model';
import {AccountStatus} from '../models/account-status.model';
import {FisicaVerficacionDatosModel} from '../models/fisica-verficacion-datos.model';
import {UserDocumentTypeListRequest} from '../models/user-document-type-list-request';
import { IInversor } from '../models/investor.model';


@Injectable({providedIn: 'root'})
export class AccountApiService {

  private readonly signupUrl = environment.apiBaseUrl + `/accounts/public/signup`;

  constructor(
    private http: HttpClient
  ) {
  }

  public signup(signupRequest: SignupRequest): Observable<any> {
    return this.http.post<any>(this.signupUrl, signupRequest);
  }


  resetPassword(code: string, token: string, password: string): Observable<any> {

    const requestBody = {
      code,
      token,
      password
    };

    return this.http.post<any>(environment.apiBaseUrl + `/accounts/public/change_password`, requestBody);
  }

  recoverPassword(email: string) {
    return this.http.post<any>(environment.apiBaseUrl + '/accounts/public/recover_password/portal', {
      email: email
    }, {observe: 'response'});
  }

  uploadProfileImage(fileType: string, imageBase64: string) {

    return this.http.post<any>(environment.apiBaseUrl + `/core/portal/profile/profile_image/upload`,
      {
        contentType: fileType,
        imageBase64: imageBase64
      });

  }

  getProfileImage() {
    return this.http.get<any>(environment.apiBaseUrl + `/core/portal/profile/profile_image`);
  }

  verifyAccount(code: string) {
    return this.http.get<any>(environment.apiBaseUrl + `/accounts/verify?requestCode=` + code);
  }

  resendVerificationCode() {
    return this.http.post<any>(environment.apiBaseUrl + `/accounts/resend_code`, {});
  }

  updateVerificationId(identityDetail: any) {
    return this.http.post<any>(environment.apiBaseUrl + `/core/portal/profile/update_verification_id`, identityDetail);
  }

  updateVerificationCompanyData(companyData: any) {
    return this.http.post<any>(environment.apiBaseUrl + `/core/portal/profile/update_verification/company_data_dinamic/async`, companyData);
  }

  /**
   * @param showLoader false para no mostrar el loader global (p. ej. polling en segundo plano
   *                   mientras el usuario sigue completando el formulario).
   */
  getJobStatus(jobId: string, showLoader: boolean = true): Observable<HttpResponse<any>> {
    return this.http.get<any>(`${environment.apiBaseUrl}/core/portal/jobs/${jobId}/status`, {
      observe: 'response',
      context: new HttpContext().set(SHOW_LOADER, showLoader)
    });
  }

  updateFisicaVerificationData(userDocumentTypeListRequest: UserDocumentTypeListRequest): Observable<any> {
    return this.http.post<any>(environment.apiBaseUrl + `/core/portal/profile/update_verification/fisica_data_dinamic`, userDocumentTypeListRequest);
  }

  getAccountStatus(): Observable<AccountStatus> {
    return this.http.get<any>(environment.apiBaseUrl + `/core/portal/profile/status`);
    // let x:AccountStatus = JSON.parse('{"userType":{"id":"JURIDICA","description":"Juridica"},"level":{"deletedDate":null,"id":"2","description":"Nivel 0","percentComplete":0,"defaultLimit":0.00},"kycStatus":"APPROVED","companyStatus":"APPROVED","limitCurrent":0.00,"limitUsed":0,"score":{"scoreBuroCrediticio":"B","scoreApp":"-","scoreTecnico":"-","score":"B"}}');
    // return of(x)
  }

  getAccountPersonalData() {
    return this.http.get<any>(environment.apiBaseUrl + `/core/portal/profile/personal_data`);
  }

  updateKycInformacionAdicionalFisicaAction(additionalInformation: any) {
    return this.http.post<any>(environment.apiBaseUrl + `/core/portal/profile/update_kyc_informacion_adicional/fisica`, additionalInformation);
  }

  updateKycInformacionAdicionalJuridicaAction(additionalInformation: any) {
    return this.http.post<any>(environment.apiBaseUrl + `/core/portal/profile/update_kyc_informacion_adicional/juridica`, additionalInformation);
  }

  requestInvestorProfile(): Observable<any> {
    return this.http.get<any>(environment.apiBaseUrl + `/core/portal/profile/inversor`);
  }
  
  getInvestorState(): Observable<IInversor> {
    return this.http.get<IInversor>(environment.apiBaseUrl + `/core/portal/profile/inversor`);
  }

  getInvestorContractToSign(url: string): Observable<any> {
    const headers = new HttpHeaders({
      'CONTENT-TYPE': 'application/pdf',
      'Accept': 'application/pdf'
    });
    const responseType = 'blob' as 'json';
    return this.http.get<Blob>(url, {headers, responseType});
  }

  sendInvestorSignature(body: any): Observable<any> {
    // const headers = new HttpHeaders({
    //   'Content-Type': 'text/plain; charset=utf-8',
    //   'Accept': 'text/plain'
    // });
    return this.http.post<any>(`${environment.apiBaseUrl}/core/portal/profile/save-user-declaracion-jurada`, body)
    // return this.http.post<any>(`${environment.apiBaseUrl}/core/portal/profile/save-user-declaracion-jurada`, body, {headers, responseType: 'text' as 'json'})
  }
}

